module.exports = __webpack_public_path__ + "71070edf36c76dc56c6f7a86c18d35ac.svg";